import { useGroupedPrice } from '@customink/project-service-react-components';
import Big from 'big.js';

export const useVolumeDiscountRatio = (designCid: string, inverse = false) => {
  const groupedPrice = useGroupedPrice(designCid);

  let volumeDiscountRatio: Big;

  try {
    volumeDiscountRatio = Big(groupedPrice?.total_base_price || 0).div(
      groupedPrice?.price_before_volume_discount || 0,
    );

    if (inverse) return Big(1).div(volumeDiscountRatio);

    return volumeDiscountRatio;
  } catch (error) {
    return Big(1);
  }
};
